/* ---------- helpers ---------- */
function money(cents) {
  const code =
    (window.Shopify && Shopify.currency && Shopify.currency.active) ||
    (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.currency) ||
    'GBP';
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: code,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);
  } catch {
    const symbols = { GBP: '£', USD: '$', EUR: '€', AUD: '$', CAD: '$' };
    const symbol = symbols[code] || code + ' ';
    return `${symbol}${((Number(cents) || 0) / 100).toFixed(2)}`;
  }
}

/* ---------- fill the two extra lines ---------- */
function updatePerDelivery(root, variant) {
  const perRaw = parseFloat(variant?.metafields?.custom?.price_per_delivery) || 0;
  const cmpRaw = parseFloat(variant?.metafields?.custom?.comparison_price) || 0;
  const perCts = Math.round(perRaw * 100);
  const cmpCts = Math.round(cmpRaw * 100);

  const perEl = root.querySelector('.price-per');
  const cmpEl = root.querySelector('.compare-per');

  // Get the correct label from data-unit-label (set in Liquid)
  const unitLabel = root.dataset.unitLabel || 'per delivery';

  // ---- price-per line (only ONE "per X" here) ----
  if (perEl) {
    if (perRaw > 0) {
      perEl.style.display = '';
      perEl.textContent = `${money(perCts)} ${unitLabel}`;
    } else {
      perEl.style.display = 'none';
      perEl.textContent = '';
    }
  }

  // ---- compare-per line (strike-through ONLY, no label) ----
  if (cmpEl) {
    if (cmpRaw > perRaw) {
      cmpEl.style.display = '';
      cmpEl.innerHTML = `<s>${money(cmpCts)}</s>`;
    } else {
      cmpEl.style.display = 'none';
      cmpEl.textContent = '';
    }
  }
}

/* ---------- web component ---------- */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const section = this.closest('.shopify-section, dialog') || document;

    // initial fill using selected variant id + window.variantPricing
    try {
      const selector =
        section.querySelector('variant-select, form select[name="id"]') ||
        document.querySelector('variant-select, form select[name="id"]');
      const initialId = selector?.value || selector?.dataset?.initialVariantId;
      if (initialId && window.variantPricing) {
        const pricing = window.variantPricing[initialId] || {};
        updatePerDelivery(this, { metafields: { custom: pricing } });
      }
    } catch {}

    // listen for common variant-change events (themes differ)
    this._ppHandler = (event) => {
      // swap the main price HTML if theme provides it in event.detail.data.html
      const newPrice = event?.detail?.data?.html?.querySelector?.(
        'product-price [ref="priceContainer"]'
      );
      const currentPrice = this.querySelector('[ref="priceContainer"]');
      if (newPrice && currentPrice && currentPrice.innerHTML !== newPrice.innerHTML) {
        currentPrice.replaceWith(newPrice);
      }

      // get a variant id from several possible event shapes
      const raw =
        event?.detail?.resource ||
        event?.detail?.variant ||
        event?.detail?.newVariant ||
        (event?.detail?.data && event.detail.data.variant);
      const variantId = raw?.id || event?.detail?.variantId;
      if (!variantId || !window.variantPricing) return;

      const pricing = window.variantPricing[variantId] || {};
      updatePerDelivery(this, { metafields: { custom: pricing } });
    };

    ['variant:update', 'variant:change', 'theme:variant:change'].forEach((evt) =>
      section.addEventListener(evt, this._ppHandler)
    );
    // global fallbacks
    ['variant:update', 'variant:change', 'theme:variant:change'].forEach((evt) =>
      document.addEventListener(evt, this._ppHandler)
    );
  }

  disconnectedCallback() {
    if (!this._ppHandler) return;
    ['variant:update', 'variant:change', 'theme:variant:change'].forEach((evt) =>
      document.removeEventListener(evt, this._ppHandler)
    );
  }
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}

/* ---------- auto-wrap if theme didn’t add <product-price> ---------- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[ref="priceContainer"]').forEach((priceContainer) => {
    if (priceContainer.closest('product-price')) return;

    const wrapper = document.createElement('product-price');
    const section = priceContainer.closest('.shopify-section, dialog');
    const idInput = section && section.querySelector('form [name="id"]');
    if (idInput?.value) wrapper.dataset.productId = idInput.value;

    // default label for cards etc.
    wrapper.dataset.unitLabel = 'per delivery';

    priceContainer.parentNode.insertBefore(wrapper, priceContainer);
    wrapper.appendChild(priceContainer);

    const comparePer = document.createElement('div');
    comparePer.className = 'compare-per';
    comparePer.style.display = 'none';

    const pricePer = document.createElement('div');
    pricePer.className = 'price-per';

    wrapper.appendChild(comparePer);
    wrapper.appendChild(pricePer);
  });
});